/*
 *   File : creator-marketing.js
 *   Author : https://evoqins.com
 *   Description : Creator Marketing Page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";


// Components
import { PrimaryButton } from "../../Component/Buttons";
import { AlphaBasketCard, CategoryTab } from "../../Component/Cards";


// Custom data
import CreatorLogo from "../../Assets/Images/Creator/creator-logo.svg";
import CuratedBasketIcon from "../../Assets/Images/Creator/curated-basket.svg";
import ActiveUsersIcon from "../../Assets/Images/Creator/active-users.svg";
import YRSExpIcon from "../../Assets/Images/Creator/years-of-experience.svg";
import CreatorImage from "../../Assets/Images/Creator/creator-image.webp";
import LeftArrow from "../../Assets/Images/Creator/left-arrow.svg";
import RightArrow from "../../Assets/Images/Creator/right-arrow.svg";


const MENU = [
    {
        id: 1,
        label: "About",
        link: "about"
    },
    {
        id: 1,
        label: "Products",
        link: "creator-baskets-section"
    },
    {
        id: 1,
        label: "FAQ",
        link: "creator-faq-section"
    },
];

const DATA = {
    creator_name: "Windmill Capital",
    tenant_info: {
        tenant_name: "Ahmed Shah",
        tenant_sebi_number: "INH200007645",
        email: "hello@windmill-capital.com",
        phone_number: "+91 72789 99009",
        address: "No 51, 3rd Floor, Le Parc Richmonde, Richmond Road, Shanthala Nagar, Bangalore – 560025",
    },
    about: `
    Windmill Capital is a forward-thinking investment management firm dedicated to helping investors achieve their financial goals through expertly crafted portfolios. Our team of seasoned research professionals leverages deep market insights and rigorous analysis to create and manage a diverse range of investment strategies. Whether you're seeking growth, value, income, or a balanced approach, Windmill Capital provides tailored solutions designed to optimize your wealth and navigate market complexities. We are committed to transparency, innovation, and delivering exceptional value to our clients, ensuring that your investments are in capable hands. Discover the power of informed investing with Windmill Capital.
    `,
    strategies: [
        {
            id: 1,
            icon: require("../../Assets/Images/Creator/strategy-growth.svg").default,
            title: "Growth",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 2,
            icon: require("../../Assets/Images/Creator/strategy-quantitative.svg").default,
            title: "Quantitative",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 3,
            icon: require("../../Assets/Images/Creator/strategy-capital-preserve.svg").default,
            title: "Capital Preservation",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 4,
            icon: require("../../Assets/Images/Creator/strategy-long-term-growth.svg").default,
            title: "Long-term Growth",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 5,
            icon: require("../../Assets/Images/Creator/strategy-thematic.svg").default,
            title: "Thematic",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 6,
            icon: require("../../Assets/Images/Creator/strategy-value-investing.svg").default,
            title: "Value-Investing",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 7,
            icon: require("../../Assets/Images/Creator/strategy-diversification.svg").default,
            title: "Diversification",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 8,
            icon: require("../../Assets/Images/Creator/strategy-buy-hold.svg").default,
            title: "Buy & Hold",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
        {
            id: 9,
            icon: require("../../Assets/Images/Creator/strategy-income-generation.svg").default,
            title: "Income Generation",
            description: `
            Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra ullamcorper lacus tortor dignissim. Lorem ipsum dolor sit amet consectetur. Fermentum ac viverra.`
        },
    ],
    top_products: {
        "alpha_basket": {
            "id": "1",
            "product_name": "alpha-basket",
            "products": [
                {
                    "strategy_id": 10001,
                    "strategy_name": "Alphaniti Nifty 50 Momentum",
                    "strategy_icon": "https://alphaniti.com/assets/files/nify50-icon.jpg",
                    "strategy_type": "Domestic",
                    "objective": "Wealth Creation",
                    "returns1m": "-1.02",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-1.33%",
                        "value": -1.33
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-9.55",
                    "returns6m": "-1.33",
                    "cagr1yr": "16.09",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "14.65%",
                        "value": 14.65
                    },
                    "cagr3yr": "14.65",
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "75310",
                    "dynamic_fixed_investment": "75310",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "3",
                        "risk_category_name": "Moderate",
                        "risk_category_abbreviation": "MO"
                    }
                },
                {
                    "strategy_id": 10002,
                    "strategy_name": "Alphaniti Nifty 200 Momentum",
                    "strategy_icon": "https://alphaniti.com/assets/files/nifty200-icon.jpg",
                    "strategy_type": "Domestic",
                    "objective": "Wealth Creation",
                    "returns1m": "-0.19",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-1.16%",
                        "value": -1.16
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-8.70",
                    "returns6m": "-1.16",
                    "cagr1yr": "27.45",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "20.13%",
                        "value": 20.13
                    },
                    "cagr3yr": "20.13",
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "75168",
                    "dynamic_fixed_investment": "75168",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "3",
                        "risk_category_name": "Moderate",
                        "risk_category_abbreviation": "MO"
                    }
                },
                {
                    "strategy_id": 10003,
                    "strategy_name": "Alphaniti NIFTY MIDCAP 150 MOMENTUM",
                    "strategy_icon": "https://alphaniti.com/assets/files/midcap-150-n.jpg",
                    "strategy_type": "Domestic",
                    "objective": "Wealth Creation",
                    "returns1m": "3.87",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-2.77%",
                        "value": -2.77
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-7.54",
                    "returns6m": "-2.77",
                    "cagr1yr": "34.11",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "29.54%",
                        "value": 29.54
                    },
                    "cagr3yr": "29.54",
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "135025",
                    "dynamic_fixed_investment": "135025",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 10004,
                    "strategy_name": "Alphaniti Nifty 100 Low Volatility",
                    "strategy_icon": "https://alphaniti.com/assets/files/midcap100.jpg",
                    "strategy_type": "Domestic",
                    "objective": "Wealth Creation",
                    "returns1m": "0.79",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "1.81%",
                        "value": 1.81
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-10.67",
                    "returns6m": "1.81",
                    "cagr1yr": "6.48",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "8.68%",
                        "value": 8.68
                    },
                    "cagr3yr": "8.68",
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "145343",
                    "dynamic_fixed_investment": "145343",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "2",
                        "risk_category_name": "Conservative",
                        "risk_category_abbreviation": "CO"
                    }
                },
                {
                    "strategy_id": 10010,
                    "strategy_name": "Alphaniti All Seasons ETF",
                    "strategy_icon": "https://alphaniti.com/assets/files/opt2.png",
                    "strategy_type": "Domestic",
                    "objective": "Wealth Creation",
                    "returns1m": "0.42",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "0.13%",
                        "value": 0.13
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-5.18",
                    "returns6m": "0.13",
                    "cagr1yr": "15.07",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "11.79%",
                        "value": 11.79
                    },
                    "cagr3yr": "11.79",
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "4891",
                    "dynamic_fixed_investment": "4891",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "2",
                        "risk_category_name": "Conservative",
                        "risk_category_abbreviation": "CO"
                    }
                },
                {
                    "strategy_id": 10011,
                    "strategy_name": "GLOBAL OPPORTUNITIES ETF",
                    "strategy_icon": "https://alphaniti.com/assets/files/global-companies.png",
                    "strategy_type": "Domestic ETF",
                    "objective": "Wealth Creation",
                    "returns1m": "15.07",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "27.96%",
                        "value": 27.96
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "30.29",
                    "returns6m": "27.96",
                    "cagr1yr": "60.50",
                    "cagr": {
                        "label": "1Y",
                        "value_str": "60.50%",
                        "value": 60.5
                    },
                    "cagr3yr": null,
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "3039",
                    "dynamic_fixed_investment": "3039",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 10012,
                    "strategy_name": "INDEX ZARA HATKE ETF",
                    "strategy_icon": "https://alphaniti.com/assets/files/INDIA-mein-jarahatkeETF.png",
                    "strategy_type": "Domestic ETF",
                    "objective": "Wealth Creation",
                    "returns1m": "2.15",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "0.44%",
                        "value": 0.44
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-7.38",
                    "returns6m": "0.44",
                    "cagr1yr": "22.85",
                    "cagr": {
                        "label": "1Y",
                        "value_str": "22.85%",
                        "value": 22.85
                    },
                    "cagr3yr": null,
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "1259",
                    "dynamic_fixed_investment": "1259",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 10013,
                    "strategy_name": "INDIA MEIN VISHWAAS ETF",
                    "strategy_icon": "https://alphaniti.com/assets/files/INDIA-mein-vishwaas-ETF.png",
                    "strategy_type": "Domestic ETF",
                    "objective": "Wealth Creation",
                    "returns1m": "2.08",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "1.14%",
                        "value": 1.14
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-6.61",
                    "returns6m": "1.14",
                    "cagr1yr": "19.48",
                    "cagr": {
                        "label": "1Y",
                        "value_str": "19.48%",
                        "value": 19.48
                    },
                    "cagr3yr": null,
                    "min_investment_type": "Dynamic",
                    "fixed_min_investment": null,
                    "min_investment": "3260",
                    "dynamic_fixed_investment": "3260",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
            ]
        },
        "alpha_basket_pro": {
            "id": "2",
            "product_name": "alpha-basket-pro",
            "products": [
                {
                    "strategy_id": 30001,
                    "strategy_name": "The Perfect PSU",
                    "strategy_icon": "https://alphaniti.com/assets/files/PSU-Basket-opt1.jpg",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "3.80",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-6.78%",
                        "value": -6.78
                    },
                    "returns_data": {
                        "label": "Returns",
                        "value": null,
                        "value_str": "₹NaN"
                    },
                    "returns3m": "-1.86",
                    "returns6m": "-6.78",
                    "cagr1yr": "54.56",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "46.37%",
                        "value": 46.37
                    },
                    "cagr3yr": "46.37",
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "28406",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30002,
                    "strategy_name": "Dividend Compounders",
                    "strategy_icon": "https://alphaniti.com/assets/files/CompoundingMachine-opt-n1.jpg",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "1.94",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-0.77%",
                        "value": -0.77
                    },
                    "returns_data": {
                        "label": "Returns",
                        "value": null,
                        "value_str": "₹NaN"
                    },
                    "returns3m": "-5.63",
                    "returns6m": "-0.77",
                    "cagr1yr": "47.45",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "46.63%",
                        "value": 46.63
                    },
                    "cagr3yr": "46.63",
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "73716",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30003,
                    "strategy_name": "Make in India",
                    "strategy_icon": "https://alphaniti.com/assets/files/makeinIndia.jpg",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "0.39",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-4.31%",
                        "value": -4.31
                    },
                    "returns_data": {
                        "label": "Returns",
                        "value": null,
                        "value_str": "₹NaN"
                    },
                    "returns3m": "-9.69",
                    "returns6m": "-4.31",
                    "cagr1yr": "35.22",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "48.33%",
                        "value": 48.33
                    },
                    "cagr3yr": "48.33",
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "42597",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30004,
                    "strategy_name": "Consumer Aspirations",
                    "strategy_icon": "https://alphaniti.com/assets/files/consumer_aspiration_3.png",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "3.56",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "9.83%",
                        "value": 9.83
                    },
                    "returns_data": {
                        "label": "Returns",
                        "value": null,
                        "value_str": "₹NaN"
                    },
                    "returns3m": "-4.21",
                    "returns6m": "9.83",
                    "cagr1yr": "35.47",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "32.48%",
                        "value": 32.48
                    },
                    "cagr3yr": "32.48",
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "127142",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30005,
                    "strategy_name": "MNC MULTICAP PLAY",
                    "strategy_icon": "https://alphaniti.com/assets/files/MNC-multicap.png",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "-1.30",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "-5.95%",
                        "value": -5.95
                    },
                    "returns_data": {
                        "label": "Returns",
                        "value": null,
                        "value_str": "₹NaN"
                    },
                    "returns3m": "-10.12",
                    "returns6m": "-5.95",
                    "cagr1yr": "33.51",
                    "cagr": {
                        "label": "3Y",
                        "value_str": "22.54%",
                        "value": 22.54
                    },
                    "cagr3yr": "22.54",
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "181841",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30006,
                    "strategy_name": "Better Health",
                    "strategy_icon": "https://alphaniti.com/assets/files/healthcare-1.png",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "0.59",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "10.64%",
                        "value": 10.64
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "-4.78",
                    "returns6m": "10.64",
                    "cagr1yr": "30.97",
                    "cagr": {
                        "label": "1Y",
                        "value_str": "30.97%",
                        "value": 30.97
                    },
                    "cagr3yr": null,
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "135928",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "4",
                        "risk_category_name": "Aggressive",
                        "risk_category_abbreviation": "AG"
                    }
                },
                {
                    "strategy_id": 30007,
                    "strategy_name": "Liquid ETF with Gold Kicker",
                    "strategy_icon": "https://alphaniti.com/assets/files/safe-liquid.png",
                    "strategy_type": "Domestic Alphamind",
                    "objective": "Wealth Creation",
                    "returns1m": "-0.21",
                    "returns": {
                        "label": "6M Returns",
                        "value_str": "1%",
                        "value": 1
                    },
                    "returns_data": {
                        "label": "XIRR",
                        "value": null,
                        "value_str": "0.00%"
                    },
                    "returns3m": "0.50",
                    "returns6m": "1",
                    "cagr1yr": "5.93",
                    "cagr": {
                        "label": "1Y",
                        "value_str": "5.93%",
                        "value": 5.93
                    },
                    "cagr3yr": null,
                    "min_investment_type": "Fixed",
                    "fixed_min_investment": "250000",
                    "min_investment": 250000,
                    "dynamic_fixed_investment": "2859",
                    "created_on": null,
                    "creator_info": null,
                    "risk_category_info": {
                        "id": "2",
                        "risk_category_name": "Conservative",
                        "risk_category_abbreviation": "CO"
                    }
                },
            ]
        }
    },
};

const TOP_PRODUCT_TAB = [
    {
        id: "alpha_basket",
        label: "alphaBasket"
    },
];

const FAQ_DATA = [
    {
        id: 1,
        question: "What is an investment basket?",
        answer: "An investment basket is a curated collection of various securities such as stocks, bonds, ETFs, and mutual funds, designed to meet specific investment goals and strategies. Each basket is professionally managed to optimize performance and minimize risk."
    },
    {
        id: 2,
        question: "How do I choose the right investment basket for me?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 3,
        question: "How often are the baskets rebalanced?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
    {
        id: 4,
        question: "Can I customize an investment basket?",
        answer: "Indvestment offers a safe and liquid way to invest your emergency funds while helping you achieve your financial goals, such as saving for retirement, a down payment on a house, or a child's education, By providing access to trending sectors and themes. The app offers both free and premium investment products tailored to your needs."
    },
];

function CreatorMarketingPage() {

    const { state } = useLocation();
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);
    const [products, setProducts] = useState(DATA.top_products["alpha_basket"].products);
    const [selectedTab, setSelectedTab] = useState(state !== null ? state : "alpha_basket");
    const [currentAccordionID, setCurrentAccordionID] = useState(1);
    const [disableRight, setDisableRight] = useState(false);

    //Function update current slide step when scrolling
    useEffect(() => {
        let container = document.querySelector(`#strategies-wrapper`);
        let first_el = document.querySelector(`.strategy-card`);
        container.addEventListener("scroll", () => {
            const scroll_step = Math.round(container.scrollLeft / first_el.offsetWidth);
            setCurrentSlide(scroll_step);
        });
    }, []);

    // Element listener to disable scroll arrows
    useEffect(() => {

        let container = document.querySelector(`#strategies-wrapper`);
        let last_element = document.querySelector(".strategy-card-last");
        let options = {
            root: container,
            rootMargin: "0px",
            threshold: 0.99 // The element is considered in view when 100%  visible
        };
        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setDisableRight(true);
                    if (currentSlide == DATA.strategies.length - 1) {
                        setCurrentSlide(DATA.strategies.length - 2);
                    }
                } else {
                    setDisableRight(false);
                }
            });
        }, options);

        observer.observe(last_element);

        return () => {
            observer.unobserve(last_element);
        };

    }, [currentSlide]);

    // const slide move left
    const _handleSlideLeft = () => {
        let element = document.querySelector(`#strategy-card-${currentSlide + 1}`);
        let container = document.querySelector(`#strategies-wrapper`);
        container.scrollBy({
            left: -element.offsetWidth,
            behavior: 'smooth'
        });

    };

    // slide move right
    const _handleSlideRight = () => {
        let element = document.querySelector(`#strategy-card-${currentSlide}`);
        let container = document.querySelector(`#strategies-wrapper`);
        container.scrollBy({
            left: element.offsetWidth,
            behavior: 'smooth'
        });
    };

    // scroll into element
    const _handleScrollToElement = (event, element_id) => {
        event.preventDefault();
        let element = document.getElementById(element_id);
        element.scrollIntoView({ top: 0, behavior: "smooth" })
    };

    // handle category tab change
    const _handleCategoryTab = (selected) => {
        navigate(window.location.pathname, {
            state: selected
        });
        setSelectedTab(selected);
        setProducts(DATA.top_products[selected].products);
    };


    // Handle toggle accordion faq
    const _handleClickFAQAccordion = (selected_faq_id) => {
        setCurrentAccordionID(selected_faq_id);
    };

    // Inline component
    const FeatureCard = (props) => {
        return (
            <div className={`${props.wrapperClassName} px-0`}>
                <div className="feature-card d-flex align-items-center gap-2 gap-sm-3 padding-12px-tb padding-18px-lr border-radius-16px">
                    <img src={props.type == 1 ? CuratedBasketIcon : props.type == 2 ? ActiveUsersIcon : YRSExpIcon}
                        alt="creator-logo"
                        className="h-40 h-30px-res-md" />
                    <div className="d-flex flex-column">
                        <span className={`${props.type == 3 ? "e-text-white" : "e-text-black"} e-font-16-res-md e-primary-font-clash-display e-font-weight-500 e-font-24`}>
                            {props.value}
                        </span>
                        <span className={`${props.type == 3 ? "e-text-white" : "e-text-outer-space"} e-font-14-res-md e-alt-font-lato e-font-weight-400 e-font-16`}>
                            {props.label}
                        </span>
                    </div>
                </div>
            </div>
        )

    };

    // Strategy card
    const StrategyCard = (props) => {
        return (
            <div className={`${props.last ? "me-4" : ""} strategy-card d-flex gap-2 flex-column padding-22px-tb px-4 border-radius-trbr-8 bg-white e-border-left-gradient-primary h-100`}>
                <div className="d-flex gap-2 align-items-center">
                    <img src={props.data.icon}
                        alt="icon"
                        height={24} />
                    <span className="e-font-16-res e-font-18 e-alt-font-lato e-text-chinese-black e-font-weight-500 line-height-30px ">
                        {props.data.title}
                    </span>
                </div>
                <p className="e-font-14 e-alt-font-lato  e-text-outer-space e-font-weight-400 line-height-20px mb-0">
                    {props.data.description}
                </p>
            </div>
        )
    };

    return (

        <div className="container-fluid p-0 m-0 overflow-x-hidden">

            {/* Navigation menu */}
            <section id="creator-nav" >
                <nav className="d-flex justify-content-between align-items-center">
                    <img src={CreatorLogo}
                        className="h-48 h-32px-res object-fit-contain"
                        draggable="false"
                        alt="creator-logo" />
                    <div className="d-flex gap-64px gap-18px-res">
                        {
                            MENU.map(((link, index) => (
                                <a href={link.link}
                                    key={index}
                                    onClick={(event) => _handleScrollToElement(event, link.link)}
                                    className="text-decoration-none e-font-14-res e-font-16 e-alt-font-lato e-text-chinese-black e-font-weight-400">
                                    {link.label}
                                </a>
                            )))
                        }
                    </div>
                </nav>
            </section>

            {/* =========== Hero section =========== */}
            <section id="creator-hero-section">
                {/* Hero section */}
                <header className="e-padding-112px-top-res e-padding-128px-top-res-md padding-184px-top padding-82px-bottom e-padding-bottom-0-res-md">
                    <div id="hero-text-wrapper"
                        className="col-sm-11 col-md-10 col-lg-8 col-xl-7 mx-auto ">
                        <div className="position-relative z-3 text-center">
                            <h1 className="line-height-32px-res e-font-24-res e-font-40-res-md col-xl-11 mx-auto e-font-48 e-primary-font-clash-display e-font-weight-500 e-text-chinese-black">
                                Transform Your <span className="e-font-weight-600">Investment Methodology</span> with {DATA.creator_name}
                            </h1>
                            <p className="mx-auto px-3 px-sm-0 col-sm-10 col-md-12 text-center e-font-14-res e-font-18-res-md e-font-20 e-alt-font-lato e-text-outer-space e-font-weight-400 line-height-26px mb-4">
                                Discover expertly crafted investment portfolios tailored to meet your financial goals.
                            </p>
                            <PrimaryButton name="View Baskets"
                                padding="padding-52px-lr padding-16px-tb"
                                onPress={() => { }} />
                        </div>
                    </div>
                </header>
            </section>

            {/* =========== Creator strategy info section =========== */}
            <section id="creator-strategy-section">
                {/* Creator image and feature cards */}
                <div id="creator-image-section"
                    className="col-sm-11 col-md-10 col-lg-9 col-xl-8 mx-auto">
                    <div className="row justify-content-between px-4 px-sm-0">
                        <FeatureCard wrapperClassName="col-auto ms-sm-5"
                            type={1}
                            value={"210+"}
                            label={"Curated Baskets"} />

                        <FeatureCard wrapperClassName="d-md-none ms-auto col-auto col-lg-3 mt-4"
                            type={2}
                            value={"10L"}
                            label={"Active Users"} />
                    </div>
                    <div className="row margin-32px-top row-gap-4 justify-content-center justify-content-sm-between">

                        <FeatureCard wrapperClassName="col-8 col-sm-auto col-lg-3 align-self-center mt-sm-5"
                            type={3}
                            value={"6+"}
                            label={"Years of Experience"} />

                        {/* creator image card */}
                        <div className="col-9 col-sm-5 me-sm-4 me-md-0 padding-30px-lr e-padding-lr-16px-res">
                            <div id="creator-card-wrapper">
                                <div id="creator-card" className="position-relative">
                                    <img src={CreatorImage} alt="creator-image" className="img-fluid" />
                                    <div className="position-absolute z-2 mb-3 bottom-0 d-flex justify-content-center flex-column w-100">
                                        <p className="e-font-14-res-md e-font-20 e-alt-font-lato e-text-chinese-black e-font-weight-700 line-height-24px text-center margin-14px-bottom">
                                            {DATA.tenant_info.tenant_name}
                                        </p>
                                        {/* SEB Info */}
                                        <div id="sebi-info"
                                            className="d-flex flex-column text-center gap-1 padding-12px-tb e-bg-magnolia-2 px-1 px-md-0">
                                            <span className="e-font-14-res-md e-font-18 e-alt-font-lato e-text-outer-space e-font-weight-400 line-height-24px">
                                                SEBI Registration Number
                                            </span>
                                            <span className="e-font-14-res-md e-font-18 e-alt-font-lato e-text-chinese-black e-font-weight-700 line-height-24px">
                                                {DATA.tenant_info.tenant_sebi_number}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <FeatureCard wrapperClassName="d-none d-md-block col-auto col-lg-3 mt-3"
                            type={2}
                            value={"10L"}
                            label={"Active Users"} />
                    </div>
                    <div className="row margin-24px-top-res margin-40px-top px-4 px-sm-0">
                        <p id="about"
                            className="line-height-24px-res e-font-14-res px-0 text-sm-center e-font-20 mb-0 e-alt-font-lato e-text-white e-font-weight-400 line-height-32px">
                            {DATA.about}
                        </p>
                    </div>
                </div>

                {/* Investment strategies */}
                <div id="investment-strategies">
                    <div className="row flex-column flex-md-row flex-nowrap gap-40px align-items-center">
                        <div className="col-md-4">
                            <h4 className="e-font-24-res e-text-gradient-primary e-font-32 e-primary-font-clash-display e-font-weight-500 line-height-40px mb-2 ">
                                Investment <br className="d-none d-md-block" /> Strategies
                            </h4>
                            <p className="e-font-16-res e-text-magnolia e-font-20 e-alt-font-lato e-font-weight-400 line-height-26px mb-4 mb-sm-5">
                                Smart Approaches for Maximizing Returns
                            </p>
                            {/* Navigation arrows */}
                            <div className="d-flex gap-4">
                                <img
                                    src={LeftArrow}
                                    className={`${currentSlide === 0 ? "opacity-50 pe-none" : "cursor-pointer"} h-52 h-40px-res-md `}
                                    alt="left-arrow"
                                    onClick={_handleSlideLeft} />
                                <img
                                    src={RightArrow}
                                    // className={`${currentSlide === DATA.strategies.length - 2 ? "opacity-50 pe-none" : "cursor-pointer"} h-52 h-40px-res-md `}
                                    className={`${disableRight ? "opacity-50 pe-none" : "cursor-pointer"} h-52 h-40px-res-md `}
                                    alt="right-arrow"
                                    onClick={_handleSlideRight} />
                            </div>
                        </div>
                        <div className="col-md-8 flex-fill overflow-hidden">
                            <div id="strategies-wrapper"
                                className="scroll-snap-wrapper d-flex gap-12px overflow-x-scroll no-scrollbar">
                                {
                                    DATA.strategies.map((item, index) => (
                                        <div className={`${index === DATA.strategies.length - 1 ? "strategy-card-last" : ""} strategy-card scroll-snap-align-start col-10 col-sm-6 col-md-7 col-xl-5`}
                                            id={`strategy-card-${index}`}
                                            data-entry={index}>
                                            <StrategyCard data={item} key={index} last={index === DATA.strategies.length - 1} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========== Section Baskets =========== */}
            <section id="creator-baskets-section">
                <h2 className="px-3 px-sm-0 e-font-20-res text-center e-text-chinese-black e-font-32 e-primary-font-clash-display e-font-weight-500 mb-2">
                    Tailored Investment Baskets for Every Goal
                </h2>
                <span className="px-3 px-sm-0 e-font-16-res d-block text-center e-font-20 e-alt-font-lato e-text-outer-space e-font-weight-400 line-height-26px">
                    Find Your Best-Fit Basket
                </span>

                {/* Basket tabs */}
                <div className='e-bg-magnolia-extra-light px-3 px-sm-0 padding-32px-tb mt-4'>
                    <div className='d-flex gap-3 justify-content-lg-center px-3 py-1 pb-2 overflow-x-auto e-manage-scrollbar'>
                        <CategoryTab data={TOP_PRODUCT_TAB}
                            activeTab={selectedTab}
                            handleTabChange={_handleCategoryTab} />
                    </div>
                </div>

                {/* List of baskets */}
                <div id="creator-baskets-wrapper">
                    <div className="row row-cols-1 row-cols-sm-2 row-gap-4 margin-40px-top">
                        {
                            products.map((product, index) => (
                                <div key={index} className='col'>
                                    <AlphaBasketCard product={product}
                                        type={4}
                                        category={selectedTab === "alpha_basket" ? 1 : 2}
                                        handleClick={() => { }} />
                                </div>
                            ))
                        }
                    </div>
                    <div className="text-center margin-40px-top">
                        <PrimaryButton name="View More"
                            padding="px-5 padding-8px-tb"
                            onPress={() => { }} />
                    </div>
                </div>
            </section>

            {/* =========== Section FAQ =========== */}
            <section id="creator-faq-section" className="e-bg-white">
                <h2 className="px-3 px-sm-0 e-font-20-res text-center e-text-chinese-black e-font-32 e-primary-font-clash-display e-font-weight-500 mb-2">
                    Frequently Asked Questions
                </h2>
                <span className="px-3 px-sm-0 e-font-16-res d-block text-center e-font-20 e-alt-font-lato e-text-outer-space e-font-weight-400 line-height-26px">
                    Lorem ipsum dolor sit amet consectetur dolor ullamcorper ullamcorper.
                </span>

                <div id="creator-faq-wrapper">
                    <div className="row">
                        <div className="col-12">
                            <div class="accordion accordion-flush d-flex flex-column"
                                id="creator-faq-accordion">
                                {
                                    FAQ_DATA.map((item, index) => (
                                        <div class={`${currentAccordionID === item.id ? "e-bg-pale-lavender" : ""} e-padding-24px-tb-res accordion-item padding-36px-tb e-border-1px-anti-flash-white`}>
                                            <h2 class="accordion-header ps-3 ps-sm-5 pe-3 pe-sm-4"
                                                onClick={() => _handleClickFAQAccordion(item.id)}>
                                                <button class={`${currentAccordionID === item.id ? "" : "collapsed"} e-font-16-res p-0 accordion-button bg-transparent shadow-none e-text-chinese-black e-alt-font-lato e-font-weight-700 e-font-20`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#creator-faq-accordion-${index + 1}`}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseOne">
                                                    {item.question}
                                                </button>
                                            </h2>
                                            <div id={`creator-faq-accordion-${index + 1}`}
                                                className={`${currentAccordionID === item.id && "show"} accordion-collapse collapse`}
                                                data-bs-parent="#creator-faq-accordion">
                                                <div class="e-font-14-res accordion-body px-3 px-sm-5 pb-0 padding-12px-top e-text-independence e-alt-font-lato e-font-weight-400 e-font-16 line-height-24px">
                                                    {item.answer}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========== Section FOOTER =========== */}
            <section id="creator-footer-section">
                <div className="container-fluid">
                    <div className="row row-gap-4 justify-content-between e-border-0-5-lavender-blue border-top-0 border-start-0 border-end-0 padding-74px-bottom">
                        {/* About */}
                        <div className="col-12 col-sm-6 col-lg-3">
                            <img src={require("../../Assets/Images/Creator/creator-logo-footer.svg").default}
                                className="object-fit-contain"
                                alt="creator-logo"
                                draggable="false"
                                height={40} />
                            <p className="e-font-14-res e-text-bright-light-gray e-font-16 e-alt-font-lato e-font-weight-400 line-height-22px my-3">
                                SEBI Registration No:
                                <span className="ps-1 e-font-weight-600">
                                    {DATA.tenant_info.tenant_sebi_number}
                                </span>
                            </p>
                            <p className="e-font-14-res e-text-bright-light-gray e-font-16 e-alt-font-lato e-font-weight-400 line-height-22px mb-0">
                                Make the right data-driven financial decisions that upgrades your portfolio.
                            </p>
                        </div>
                        {/* Links */}
                        <div className="col-12 col-sm-6 offset-md-1 col-md-2">
                            <h6 className="e-font-16-res e-text-magnolia e-font-18 e-primary-font-clash-display e-font-weight-500 e-text-chinese-black line-height-24px">
                                Links
                            </h6>
                            <div className="d-flex flex-column gap-2 gap-sm-3">
                                <a href="" className="">Terms and Conditions</a>
                                <a href="">Privacy Policy</a>
                            </div>
                        </div>
                        {/* Contact */}
                        <div className="col-12 col-sm-6 col-md-3 ps-lg-5">
                            <h6 className="e-font-16-res e-text-magnolia e-font-18 e-primary-font-clash-display e-font-weight-500 e-text-chinese-black line-height-24px">
                                Contact Us
                            </h6>
                            <div className="d-flex flex-column gap-2">
                                <a href={`tel:+${DATA.tenant_info.phone_number}`}>
                                    {DATA.tenant_info.phone_number}
                                </a>
                                <a href={`mailto:${DATA.tenant_info.email}`}>
                                    {DATA.tenant_info.email}
                                </a>
                            </div>
                        </div>
                        {/* location */}
                        <div className="col-12 col-sm-6 col-md-3">
                            <h6 className="e-font-16-res e-text-magnolia e-font-18 e-primary-font-clash-display e-font-weight-500 e-text-chinese-black line-height-24px">
                                Location
                            </h6>
                            <p className="e-font-14-res e-text-magnolia e-font-16 e-alt-font-lato e-font-weight-400 line-height-22px mb-0">
                                {DATA.tenant_info.address}                            </p>
                        </div>
                    </div>

                    {/* COPY right */}
                    <div className="row mt-4">
                        <div className="col d-flex align-items-center justify-content-center">
                            <span className="d-flex align-items-center flex-wrap gap-2 e-text-lavender-light e-font-14 e-alt-font-lato e-font-weight-400">
                                <span className="order-2 order-sm-1">
                                    © {new Date().getFullYear()} — Copyright All Rights reserved by
                                </span>
                                <img src={require("../../Assets/Images/Creator/indvestmer-logo.svg").default}
                                    className="order-1 order-sm-2 object-fit-contain h-18 h-12px-res"
                                    alt="indvestmer-logo"
                                    draggable="false" />
                            </span>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default CreatorMarketingPage;